<template>
  <v-row>
    <v-col cols="6">
      <div class="overline">Namn</div>
      <div class="body-1">
        <router-link :to="'/companies/' + company.id">
          {{ company.name }} {{ company.organizationalNumber | filterOrgNo }}
        </router-link>
      </div>
    </v-col>
    <v-col
      v-if="company.contracttype && company.contracttype.name"
      cols="6"
    >
      <div class="overline">Avtalstyp</div>
      <div class="body-1">{{ company.contracttype.name }}</div>
    </v-col>
  </v-row>
</template>

<script>
import {Utilities} from '@/components/mixins'
import {mapGetters} from 'vuex'

export default {
  name: 'ApplicationCompanyView',

  mixins: [Utilities],

  props: {
    company: {
      type: Object,
      required: true
    },

    application: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('application', ['applicationDepartments'])
  },

  methods: {
    filteredDepartments() {
      let ret
      if (this.application.workplaceId && this.applicationDepartments)
        ret = this.applicationDepartments.filter(dep => dep.workplaceIds.find(u => u == this.application.workplaceId))
      return ret
    }
  }
}
</script>

<style lang="scss" scoped>
</style>